<mat-toolbar color="primary" class="mat-elevation-z6">
  <ng-content></ng-content>
<!--  <small class="welcome-back">{{'welcome.welcome' | translate}} {{authService.getProfile().firstname}} {{authService.getProfile().lastname}}</small>-->
  <div style="margin: 0 auto;text-align: center">
    <img class="mini-icon">
    <span>&nbsp;{{appName}}</span>
  </div>

  <button mat-button (click)="logout()">
    Sign Out
    <mat-icon inline>logout</mat-icon>
  </button>
</mat-toolbar>
